import React from 'react';
import './tablecontainer.css';

interface TableContainerProps {
  children: React.ReactNode;
}

function TableContainer({ children }: TableContainerProps) {
  return (
    <div className="table__container">
      <table className="admin__content">
        <tbody>{children}</tbody>
      </table>
    </div>
  );
}

export default TableContainer;
